import { render, staticRenderFns } from "./vue-horizontal-list.vue?vue&type=template&id=7685ec72&scoped=true&"
import script from "./vue-horizontal-list.vue?vue&type=script&lang=js&"
export * from "./vue-horizontal-list.vue?vue&type=script&lang=js&"
import style0 from "./vue-horizontal-list.vue?vue&type=style&index=0&id=7685ec72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7685ec72",
  null
  
)

export default component.exports